/*
  Dynamic collection order (REC-COLLECTION-SORT-1) – snippets/timi-collection-sort.liquid.
  Design: Documentation/Rekommendationer/REC_COLLECTION_SORT_DESIGN_2026-10-17.md §4.
  - The engine query (GET <endpoint>?surface=collection_sort&collection=<id>&market=&plating=&mode=market|person&client=&rv=&wl=
    &limit=250 (&wd=1 when navigator.webdriver), answer {holdout, personal, basis, order, tail, head}) is sent by the snippet's
    inline starter BEFORE the grid is parsed (window.TimiSort: ask = the promise, cached = a fresh answer from sessionStorage,
    hold = this tab is in the holdout) – REC-COLLECTION-SORT-TIMING-1. This file is loaded async and only uses it.
  - Only page 1, only without ?sort_by= / filter.* (also checked in Liquid), only before the grid is shown: the snippet
    hides the cards (visibility); the hide time counts from the moment the grid's last card is parsed (the snippet's end mark
    after the grid, else DOMContentLoaded) and is at most cfg.wait ms (max 300) from THAT moment. If no answer is here by then
    the collection's own order stays and NOTHING moves later (no layout shift after the grid is visible) – a move is refused
    whenever the cards are already visible.
  - Late answers are not lost: the starter keeps them in sessionStorage (5 min), so the next page view sorts at once from the
    cache. If the live answer is late but this tab has an answer for the same collection, market and mode from the last 5 min
    (other signals), that one is used just before the deadline (cached: true in the event).
  - Reorders the cards in the DOM (not CSS order), so tab order = what the eye sees. If focus is already inside the
    grid nothing is moved.
  - order = best first: cards in it go first in that order, then the other page-1 cards in the shop's order, then the
    cards in tail (sold out in the market). head = the first 40 of order with handles: up to cfg.pull of them that are
    NOT on page 1 and rank within page 1's length are fetched as the grid's own card (sections/rec-grid-item.liquid,
    within the collection – as the For you row does; the starter starts these requests as soon as the answer is known)
    and put in at their place, in the same wait. Page 1 then shows
    up to pull extra cards; they still also sit on their own server page (pagination is Shopify's).
  - Mix (TILLÄGG 3): the collection's own sort is the mode. Newest first (cfg.base = created-descending, cfg.news > 0): the query
    carries base, news = page 1's first 20 product ids in the shop's order and news_n; the engine keeps news_n of them (in stock)
    on places spread over the first 20 and puts the market + personal order around them. Other sorts: market + personal.
  - holdout (10 %, the rec rows' clientId hash): order = [] – the collection's own order; same hide time as everyone.
  - Signals for mode person: rv = the wishlist app's Visited list (localStorage timi_wl_visited), wl = the wishlist ids
    remembered in sessionStorage from the visitor's last /apps/wishlist/state (fetched AFTER the order, for the next page
    – never waited for), client = Shopify's clientId only when the analytics library ALREADY has it (no wait). When the query
    went without it and the clientId turns up later on the page, one query with it is sent after the grid is shown, only to
    learn this tab's holdout bit (sessionStorage timi_sort_h) and to fill the cache for the next page.
    No consent gate (decision 2026-10-16): a visitor who blocks storage has no rv/wl and gets the market's order.
  - Measuring: timi:collection_sort {collection_id, result, holdout, personal, basis, moved, pulled, ms, cached} once per page
    (cached = the order came from sessionStorage, not from this page's query),
    timi:collection_click {collection_id, position, product_id, result, holdout, pulled, personal, slot} per product click
    (Shopify.analytics.publish, for the pixel/collector). No clientId or product list is published.
    REC-COLLECTION-SORT-MEASURE-1 (2026-10-17): pulled = the card was fetched from a later page (data-timi-sort-pulled),
    personal = the engine put the product in as a personal product (answer.pers -> data-timi-sort-personal), slot = the product's
    1-based place in the engine's order (only when it is in it - left out otherwise). The holdout bit in the answer is the
    order's OWN holdout (timi-api: own salt, independent of the rec rows' holdout).
*/
(function () {
  var cfgEl = document.querySelector('script[data-timi-sort-config]');
  if (!cfgEl || window.TimiCollectionSortRan) return;
  window.TimiCollectionSortRan = true;
  var S = window.TimiSort || null;
  var cfg = S && S.cfg;
  if (!cfg) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; } }
  var html = document.documentElement;
  var start = S ? S.start : Date.now();
  var deadline = 0;
  var done = false;
  var have = false;
  var grid = null;
  var state = { result: 'pending', holdout: false, personal: false, basis: '', moved: 0, pulled: 0, cached: false, rank: {} };

  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  function left() { return deadline - Date.now(); }

  function visible() { return !html.classList.contains('timi-sort-pending'); }

  function reveal(result) {
    if (done) return;
    done = true;
    state.result = result;
    html.classList.remove('timi-sort-pending');
    if (grid) {
      grid.dataset.timiSort = result;
      grid.removeAttribute('aria-busy');
    }
    publish('timi:collection_sort', { collection_id: cfg.collection, result: result, holdout: state.holdout, personal: state.personal,
      basis: state.basis, moved: state.moved, pulled: state.pulled, ms: Date.now() - start, cached: state.cached });
    after();
  }

  function productGrid() {
    var all = document.querySelectorAll('[data-section-type="collection-grid"] .grid--uniform');
    for (var i = 0; i < all.length; i++) if (!all[i].closest('rec-row')) return all[i];
    return null;
  }

  function cards(g) {
    return Array.prototype.filter.call(g.children, function (el) {
      return el.tagName !== 'REC-ROW' && /(^|\s)grid__item(\s|$)/.test(el.className) && el.getAttribute('data-product-id');
    });
  }

  function whenClient(ms) {
    return new Promise(function (resolve) {
      var until = Date.now() + ms;
      (function poll() {
        var c = S.client();
        if (c || Date.now() >= until) return resolve(c);
        setTimeout(poll, 100);
      })();
    });
  }

  // For the next page view: the wishlist as /apps/wishlist/state has it (only when the visitor already has one).
  function refreshWishlist() {
    var guest = null;
    try { guest = localStorage.getItem('timi_wl_guest'); } catch (e) {}
    if (!guest && !(window.TimiWishlist && TimiWishlist.loggedIn)) return;
    fetch('/apps/wishlist/state' + (guest ? '?g=' + encodeURIComponent(guest) : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) {
        try { sessionStorage.setItem('timi_sort_wl', JSON.stringify({ at: Date.now(), ids: (d.product_ids || []).map(String).slice(0, 50) })); } catch (e) {}
      }).catch(function () {});
  }

  // After the grid is shown: the wishlist for the next page, and – when this page's query went without a clientId that exists
  // now – one query with it, only so the next page knows the holdout bit and has a cached answer. Nothing on this page moves.
  function after() {
    if (!S || !S.query) return;
    if (S.query.mode === 'person') refreshWishlist();
    if (S.hold || S.query.client || S.query.wd || S.get('timi_sort_h') !== null) return;
    whenClient(5000).then(function (c) {
      if (!c || S.get('timi_sort_h') !== null) return;
      var q = {};
      Object.keys(S.query).forEach(function (k) { q[k] = S.query[k]; });
      q.client = c;
      S.send(q).catch(function () {});
    });
  }

  // The grid's own card for a product from a later page (as rec-row.js gridCard: within the collection). The starter has
  // usually started the request already (S.cards, as soon as the answer was known); otherwise it starts here.
  // Never later than ms: a card that is not here by then is left out (the abort alone is not enough everywhere).
  function card(h, ms) {
    var url = String(cfg.collectionUrl || '').replace(/\/$/, '') + '/products/' + encodeURIComponent(h.handle) + '?section_id=rec-grid-item';
    var early = S && S.cards && S.cards[h.product_id];
    var ctrl = !early && window.AbortController ? new AbortController() : null;
    var timer = ctrl && setTimeout(function () { ctrl.abort(); }, Math.max(ms, 1));
    var late = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, Math.max(ms, 1)); });
    var text = early || fetch(url, { signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
    return Promise.race([late, text.then(function (text) {
      if (!text) throw new Error('no card');
      var box = document.createElement('div');
      box.innerHTML = text;
      var el = box.querySelector('[data-rec-grid-item] > .grid__item');
      if (!el) throw new Error('no card');
      return el;
    }).catch(function () { return null; }).finally(function () { if (timer) clearTimeout(timer); })]);
  }

  // New order of the cards: in `order` first (that order), the rest of page 1 in the shop's order, sold out last.
  function plan(have, order, tail) {
    var byId = {};
    have.forEach(function (el) { byId[el.getAttribute('data-product-id')] = el; });
    var out = [], used = {}, sold = {};
    (tail || []).forEach(function (id) { sold[String(id)] = true; });
    (order || []).forEach(function (id) {
      var k = String(id);
      if (byId[k] && !used[k] && !sold[k]) { out.push(byId[k]); used[k] = true; }
    });
    have.forEach(function (el) {
      var k = el.getAttribute('data-product-id');
      if (!used[k] && !sold[k]) { out.push(el); used[k] = true; }
    });
    have.forEach(function (el) {
      var k = el.getAttribute('data-product-id');
      if (!used[k]) { out.push(el); used[k] = true; }
    });
    return out;
  }

  function apply(answer, pulledEls) {
    if (done) return;
    if (visible()) return reveal('timeout');          // the cards already show: never move them
    var active = document.activeElement;
    if (active && active !== document.body && grid.contains(active)) return reveal('focus');
    var page = cards(grid);
    var cls = page.length ? page[0].className : '';
    var pulled = (pulledEls || []).filter(Boolean).map(function (el) {
      if (cls) el.className = cls;
      el.setAttribute('data-timi-sort-pulled', '');
      return el;
    });
    var before = page.map(function (el) { return el.getAttribute('data-product-id'); }).join(',');
    var row = Array.prototype.filter.call(grid.children, function (el) { return el.tagName === 'REC-ROW'; })[0];
    var rowAt = row ? cards(grid).filter(function (el) { return row.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING; }).length : -1;
    var mine = {};
    (Array.isArray(answer.pers) ? answer.pers : []).forEach(function (id) { mine[String(id)] = true; });
    page.concat(pulled).forEach(function (el) { if (mine[el.getAttribute('data-product-id')]) el.setAttribute('data-timi-sort-personal', ''); });
    var next = plan(page.concat(pulled), answer.order, answer.tail);
    var frag = document.createDocumentFragment();
    next.forEach(function (el) { frag.appendChild(el); });
    grid.appendChild(frag);
    if (row) {
      var now = cards(grid);
      grid.insertBefore(row, now[rowAt] || null);
    }
    state.pulled = pulled.length;
    state.moved = next.filter(function (el, i) { return page[i] !== el; }).length;
    reveal(before === next.map(function (el) { return el.getAttribute('data-product-id'); }).join(',') ? 'same' : 'sorted');
  }

  // An answer (live or from the cache) -> the page: holdout / nothing to do / page 1 sorted with up to cfg.pull cards from later pages.
  function use(answer, cached, pull) {
    if (done || !answer || !Array.isArray(answer.order)) return;
    have = true;
    state.holdout = !!answer.holdout;
    state.personal = !!answer.personal;
    state.basis = answer.basis || '';
    state.cached = !!cached;
    if (answer.holdout) return reveal('holdout');
    answer.order.forEach(function (id, i) { var k = String(id); if (!state.rank[k]) state.rank[k] = i + 1; });
    if (!answer.order.length && !(answer.tail || []).length) return reveal('manual');
    var page = cards(grid);
    var onPage = {};
    page.forEach(function (el) { onPage[el.getAttribute('data-product-id')] = true; });
    var want = !pull ? [] : (answer.head || []).filter(function (h, i) {
      return i < page.length && h && h.handle && !onPage[String(h.product_id)];
    }).slice(0, Math.max(0, Number(cfg.pull) || 0));
    if (!want.length || !cfg.collectionUrl || left() <= 60) return apply(answer, []);
    return Promise.all(want.map(function (h) {
      return card(h, left() - 30).then(function (el) {
        if (el && String(el.getAttribute('data-product-id')) !== String(h.product_id)) el.setAttribute('data-product-id', String(h.product_id));
        return el;
      });
    })).then(function (els) { apply(answer, els); });
  }

  // Just before the starter's own timer shows the grid: the last answer this tab has for the collection (5 min), else the own order.
  function lastChance() {
    if (done || have) return;
    var c = S.query && !S.query.wd && S.get(S.key);
    if (c && c.answer && Date.now() - c.at < 300000) use(c.answer, true, false);
    if (!done) reveal('timeout');
  }

  function run() {
    grid = productGrid();
    if (!grid || !cfg.endpoint) return reveal('manual');
    if (/[?&](sort_by|filter\.)/.test(location.search)) return reveal('user_choice');
    if (!S || !S.gridAt) return reveal('manual');
    deadline = S.gridAt + S.wait;
    grid.setAttribute('aria-busy', 'true');
    grid.addEventListener('click', function (evt) {
      var a = evt.target.closest && evt.target.closest('a[href]');
      var item = a && a.closest('.grid__item[data-product-id]');
      if (!item || item.parentNode !== grid) return;
      var pid = item.getAttribute('data-product-id');
      var d = { collection_id: cfg.collection, position: cards(grid).indexOf(item) + 1, product_id: Number(pid), result: state.result,
        holdout: state.holdout, pulled: item.hasAttribute('data-timi-sort-pulled'), personal: item.hasAttribute('data-timi-sort-personal') };
      if (state.result === 'sorted' || state.result === 'same') { if (state.rank[pid]) d.slot = state.rank[pid]; }
      publish('timi:collection_click', d);
    }, true);
    setTimeout(lastChance, Math.max(left() - 15, 0));
    if (S.hold) { state.holdout = true; return reveal('holdout'); }
    if (S.cached) return use(S.cached, true, true);
    if (!S.ask) return reveal('manual');
    S.ask.then(function (answer) { use(answer, false, true); }, function () { if (left() > 15) reveal('manual'); });
  }

  // async: this may run before the grid is parsed – wait for the starter's mark (or the document, when the starter did not run).
  if (S && !S.gridAt) document.addEventListener('timi:sort-grid', run);
  else if (!S && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
